export default "__VITE_ASSET__I$flgIoU__"